import { createGlobalStyle } from 'styled-components'
import { fontConfig } from './fonts'
import { container, display, grid } from './utils'

export const breakpoints = {
  xs: '576px',
  sm: '576px',
  md: '768px',
  lg: '992px',
  xl: '1200px',
  xxl: '1400px',
}
export const containerMaxWidths = {
  xs: '100%',
  sm: '540px',
  md: '720px',
  lg: '960px',
  xl: '1140px',
  xxl: '1320px',
}

// styles
const GlobalStyle = createGlobalStyle`

//variables
:root{
  --dark-blue: #24143e;
  --light-blue: #00ceff;
  --orange: #f2662e;
  --dark-gray: #3a3a3a;
  --light-gray: #9c9c9c;
  --red: #ff5b5b
}

//fonts
${fontConfig()}

//reset
* {
  font-family: 'Omnes';
  font-weight: lighter;
  margin: 0;
  padding: 0;
  border: none;
}
::placeholder {
  color: rgba(0,0,0,.4);
}
html,
body,
#root {
  height: 100%;
  min-height: 100%;
  overflow-x:hidden;
}

#root {

  *, *::before, *::after{
  box-sizing: border-box;
  }
  ul {
    list-style-type:none;
  }
  a,
  button {
    cursor: pointer;
  }
  h1, h2, h3, h4, h5, h6, p {
    margin-bottom: 0
  }


  h1, h2, h3, h4, h5, h6, strong, b {
    font-weight: bold;
  }
  :disabled {
    cursor: no-drop;
  }
}

  //grid system
  .d-none {
    display: none;
  }
  .d-block {
    display: block;
  }
  .py-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-5 {
    padding-top: 5px !important;
    padding-bottom: 5px !important;
  }

  .container {
    width: ${containerMaxWidths.xs};
    margin: 0 auto;
    transition: all .5s
  }
  .row {
    display: flex;
    flex-wrap: wrap;
    margin: 0 -5px;
  }
  [class*="col-"] {
    padding: 5px 5px;
    transition: all .5s;
  }
  ${grid()}
  .no-gutters [class*="col-"] {
    padding:0;
  }
  .no-gutters-x [class*="col-"] {
    padding-left:0;
    padding-right:0;
  }
  .no-gutters-y [class*="col-"] {
    padding-top:0;
    padding-bottom:0;
  }

  .field-url {
    margin-top:10px;
  }

// Media Extra small (xs)
@media screen and (max-width: ${breakpoints.xs}) {
  ${grid('xs')}
  ${display('xs', 'block')}
  ${display('xs', 'none')}
  ${container(containerMaxWidths.xs)}

  .container {
    padding: 0 20px;
    box-sizing: border-box;
  }
}
// Media Small (sm)
@media screen and (min-width: ${breakpoints.sm}) {
  ${grid('sm')}
  ${display('sm', 'block')}
  ${display('sm', 'none')}
  ${container(containerMaxWidths.sm)}

}
// Media Medium (md)
@media screen and (min-width: ${breakpoints.md}) {
  ${grid('md')}
  ${display('md', 'block')}
  ${display('md', 'none')}
  ${container(containerMaxWidths.md)}
}
// Media Large (lg)
@media screen and (min-width: ${breakpoints.lg}) {
  ${grid('lg')}
  ${display('lg', 'block')}
  ${display('lg', 'none')}
  ${container(containerMaxWidths.lg)}
}
// Media Extra large (xl)
@media screen and (min-width: ${breakpoints.xl}) {
  ${grid('xl')}
  ${display('xl', 'block')}
  ${display('xl', 'none')}
  ${container(containerMaxWidths.xl)}
}
// Media Extra extra large (xxl)
@media screen and (min-width: ${breakpoints.xxl}) {
  ${grid('xxl')}
  ${display('xxl', 'block')}
  ${display('xxl', 'none')}
  ${container(containerMaxWidths.xxl)}
}
`

export default GlobalStyle
